import { takeLeading } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';
import * as actions from './taxFormsActions';
import { getLastSyncDate } from './taxFormsSelectors';
import { transformResponseToTaxForms } from './taxFormsTransformers';
import type { TaxFormType } from './taxFormsTypes';

const mkTaxFormsResourceConfig = resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<TaxFormType>();

const mkResourceConfig = () =>
  mkTaxFormsResourceConfig({
    resourceName: 'tax-forms',
    resourceBaseUrl: 'categories/tax-forms',
    getLastSyncDate,
    transformResponseToResources: transformResponseToTaxForms,
    successAction: actions.getTaxFormsSuccess,
    failureAction: actions.getTaxFormsFailure,
  });

export function* getTaxFormsActionWatcher() {
  const resourceConfig = mkResourceConfig();
  yield takeLeading(actions.getTaxForms.type, resourceSagaUtils.qcsSyncGetResources<TaxFormType>, resourceConfig);
}

export default [getTaxFormsActionWatcher];
